// export const HOOKS_URL = 'http://localhost:8000/wordpress-hooks-passthrough.php';
export const HOOKS_URL = './wordpress-hooks.json';
